import { Box, Typography } from '@mui/material';
import { winStatusColumns } from '../table/DashboardData';
import { Tables } from '@/component/pools/table/Tables';
import { ResReadWinStatusType, ResReadWinType } from '@/types';
import { packBigNumbers } from '@/lib/BigNumbers';
import BigNumber from 'bignumber.js';

export default function WinStatus({ datas }: { datas: ResReadWinType }) {
  // datas는 이미 배열이므로 직접 사용
  let count = BigNumber(0);
  const list: ResReadWinStatusType[] = datas.data.map((data) => {
    count = count.plus(data.count.toString());
    return {
      name: data.name,
      win_amount: packBigNumbers(data.win_amount),
      count: packBigNumbers(data.count.toString()),
    };
  });

  return (
    <Box sx={{ mb: 3, px: 2, width: '100%' }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        당첨 상태
      </Typography>
      <Box sx={{ width: '100%' }}>
        total: {packBigNumbers(datas.tot_amount)} / count: {packBigNumbers(count.toString())}
        {list && <Tables list={list} columns={winStatusColumns} getRowId={(row) => row.name} />}
      </Box>
    </Box>
  );
}
